// utils/request.ts
import axios from "axios";

const request = axios.create({
  baseURL: "/api", // 替换为你的接口地址
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器（可选）
request.interceptors.request.use(
  (config) => {
    // 例如添加 token
    // config.headers.Authorization = `Bearer ${token}`
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器（可选）
request.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
    return [];
  },
  (error) => {
    console.error("API Error:", error);
    return [];
  }
);

export default request;
